<div class="header">
  <div class="title" trans>Links</div>
  <div class="subtitle" trans>Configure various link behaviour across the site.</div>
</div>

<form
  class="body"
  (ngSubmit)="saveSettings()"
  *ngIf="state.errors$ | async as errors"
  ngNativeValidate
>
  <mat-tab-group color="accent" animationDuration="0">
    <mat-tab [label]="'Behaviour' | trans">
      <div class="many-inputs">
        <div class="error-group">
          <div class="setting-toggle-container">
            <mat-slide-toggle
              name="links.enable_type"
              id="links.enable_type"
              [(ngModel)]="state.client['links.enable_type']"
              trans
              >Type Selection</mat-slide-toggle
            >
            <p trans>Whether user should be able to change type when creating or updating links.</p>
          </div>

          <div class="input-container">
            <label for="links.default_type" trans>Default Link Type</label>
            <select
              name="links.default_type"
              id="links.default_type"
              [(ngModel)]="state.client['links.default_type']"
            >
              <option value="direct" trans>Direct</option>
              <option value="frame" trans>Frame</option>
              <option value="splash" trans>Splash</option>
            </select>
            <p trans>
              What type should newly created links have by default (If user did not manually select
              type).
            </p>
          </div>

          <div class="inline-inputs-container">
            <div class="input-container">
              <label for="links.min_len" trans>Link Min Length</label>
              <input
                type="number"
                id="links.min_len"
                name="links.min_len"
                [(ngModel)]="state.client['links.min_len']"
                min="1"
                required
              />
            </div>

            <div class="input-container">
              <label for="links.max_len" trans>Link Max Length</label>
              <input
                type="number"
                id="links.max_len"
                name="links.max_len"
                [(ngModel)]="state.client['links.max_len']"
                min="1"
                max="2000"
                required
              />
            </div>
          </div>
          <p class="inline-inputs-description" trans>
            Specify minimum and maximum length for urls that users will be able to shorten.
          </p>

          <div class="inline-inputs-container">
            <div class="input-container">
              <label for="links.alias_min" trans>Alias Min Length</label>
              <input
                type="number"
                id="links.alias_min"
                name="links.alias_min"
                [(ngModel)]="state.client['links.alias_min']"
                min="1"
                required
              />
            </div>

            <div class="input-container">
              <label for="links.alias_max" trans>Alias Max Length</label>
              <input
                type="number"
                id="links.alias_max"
                name="links.alias_max"
                [(ngModel)]="state.client['links.alias_max']"
                min="1"
                max="50"
                required
              />
            </div>

            <div class="input-container">
              <label for="links.alias_content">Alias Content</label>
              <select
                id="links.alias_content"
                name="links.alias_content"
                [(ngModel)]="state.client['links.alias_content']"
              >
                <option value="alpha_dash" trans>Numbers, letters, underscore and dash</option>
                <option value="alpha_num" trans>Numbers or letters</option>
                <option value="alpha" trans>Letters only</option>
                <option value="numeric" trans>Numbers only</option>
              </select>
            </div>
          </div>
          <p class="inline-inputs-description" trans>
            Specify minimum and maximum length as well as what characters link alias are allowed to
            contain.
          </p>
        </div>

        <div class="error-group no-border-top">
          <div class="setting-toggle-container">
            <mat-slide-toggle
              name="links.retargeting"
              id="links.retargeting"
              [(ngModel)]="state.client['links.retargeting']"
              trans
              >Enable Link Retargeting</mat-slide-toggle
            >
            <p trans>Whether redirection based on location, device or platform is enabled.</p>
          </div>

          <div class="setting-toggle-container">
            <mat-slide-toggle
              name="links.pixels"
              id="links.pixels"
              [(ngModel)]="state.client['links.pixels']"
              trans
              >Enable Tracking Pixels</mat-slide-toggle
            >
            <p trans>Whether user should be able to apply tracking pixels to links.</p>
          </div>

          <div class="input-container">
            <label for="links.redirect_time" trans>Splash Page Redirect Time</label>
            <input
              type="number"
              name="links.redirect_time"
              id="links.redirect_time"
              [(ngModel)]="state.client['links.redirect_time']"
              min="0"
              max="60"
            />
            <p trans>
              After how many seconds should user be redirect to their destination on splash page. In
              Seconds. 0 will disable automatic redirection.
            </p>
          </div>
        </div>

        <div class="error-group no-border-top">
          <div class="setting-toggle-container">
            <mat-slide-toggle
              name="links.homepage_creation"
              id="links.homepage_creation"
              [(ngModel)]="state.client['links.homepage_creation']"
              trans
              >Homepage Link Creation</mat-slide-toggle
            >
            <p trans>Whether non-logged in users can shorten links on homepage.</p>
          </div>

          <div class="setting-toggle-container">
            <div class="input-container">
              <label for="links.home_expiration">Expire links created from homepage</label>
              <select
                name="links.home_expiration"
                id="links.home_expiration"
                [(ngModel)]="state.client['links.home_expiration']"
                trans
              >
                <option [ngValue]="null" trans>Never</option>
                <option value="1day">After one day</option>
                <option value="3days">After three days</option>
                <option value="7days">After a week</option>
              </select>
            </div>
          </div>
        </div>

        <div class="setting-toggle-container">
          <mat-slide-toggle
            name="links.homepage_stats"
            id="links.homepage_stats"
            [(ngModel)]="state.client['links.homepage_stats']"
            trans
            >Show Homepage Stats</mat-slide-toggle
          >
          <p trans>
            Whether statistics about about number of links, clicks and users should be displayed on
            homepage.
          </p>
          <mat-slide-toggle
            name="links.dash_footer"
            id="links.dash_footer"
            [(ngModel)]="state.client['links.dash_footer']"
            trans
            >Show Footer in Dashboard</mat-slide-toggle
          >
        </div>

        <div class="input-container">
          <label for="links.gchart_api_key" trans>Google Maps Javascript API Key</label>
          <input
            type="text"
            name="links.gchart_api_key"
            id="links.gchart_api_key"
            [(ngModel)]="state.client['links.gchart_api_key']"
          />
          <p trans>Required in order to show world geochart on link and group report pages.</p>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Security' | trans">
      <div class="many-inputs security-tab">
        <div class="error-group many-inputs">
          <div class="input-container">
            <label for="links.blacklist.keywords" trans>Blacklist Keywords</label>
            <textarea
              name="links.blacklist.keywords"
              id="links.blacklist.keywords"
              [(ngModel)]="state.client['links.blacklist.keywords']"
            ></textarea>
            <p trans>
              Comma separated list of keywords. User will not be able to shorten any URLs that
              contain specified keywords.
            </p>
          </div>

          <div class="input-container">
            <label for="links.blacklist.domains" trans>Blacklist Domains</label>
            <textarea
              name="links.blacklist.domains"
              id="links.blacklist.domains"
              [(ngModel)]="state.client['links.blacklist.domains']"
            ></textarea>
            <p trans>
              Comma separated domain list (domain1.com, domain2.com etc.). User will not be able to
              shorten any URLs from specified domains.
            </p>
          </div>
        </div>

        <div
          class="input-container"
          id="safebrowsing_group"
          [class.has-error]="errors.safebrowsing_group"
        >
          <label for="links.google_safe_browsing_key" trans>Google Safe Browsing API Key</label>
          <input
            type="text"
            name="links.google_safe_browsing_key"
            id="links.google_safe_browsing_key"
            [(ngModel)]="state.client['links.google_safe_browsing_key']"
          />
          <p trans>
            Entering this API key will prevent urls that are considered unsafe by google from being
            shortened.
          </p>
          <p class="error" *ngIf="errors.safebrowsing_group">{{ errors.safebrowsing_group }}</p>
        </div>

        <div
          class="input-container"
          id="phishtank_group"
          [class.has-error]="errors.phishtank_group"
        >
          <label for="links.phishtank_key" trans>Phishtank API Key</label>
          <input
            type="text"
            name="links.phishtank_key"
            id="links.phishtank_key"
            [(ngModel)]="state.client['links.phishtank_key']"
          />
          <p trans>
            Entering this API key will prevent urls that are considered unsafe by Phishtank from
            being shortened.
          </p>
          <p class="error" *ngIf="errors.phishtank_group">{{ errors.phishtank_group }}</p>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Domains' | trans">
      <div class="error-group">
        <div class="input-container default-domain-input-container">
          <label for="custom-domains-default-host" trans>Default Domain</label>
          <select
            id="custom-domains-default-host"
            name="custom-domains-default-host"
            [(ngModel)]="state.client['custom_domains.default_host']"
          >
            <option [value]="''">{{ defaultDomain }}</option>
            <option [value]="domain.host" *ngFor="let domain of customDomains$ | async">
              {{ domain.host }}
            </option>
          </select>
          <p trans>Which domain should be used by default for links.</p>
        </div>

        <div class="setting-toggle-container margin-top">
          <mat-slide-toggle
            id="custom-domains-allow-select"
            name="custom-domains-allow-select"
            [(ngModel)]="state.client['custom_domains.allow_select']"
            trans
            >Allow Domain Selection</mat-slide-toggle
          >
          <p trans>Allow users to select which domain they want to use for each link.</p>
        </div>

        <div class="setting-toggle-container margin-top">
          <mat-slide-toggle
            id="subdomain-link-match"
            name="subdomain-link-match"
            [(ngModel)]="state.client['links.subdomain_matching']"
            trans
            >Subdomain Link Matching</mat-slide-toggle
          >
          <p trans>
            When this is enabled both "linkId.site.com" or "site.com/linkId" short urls will work.
          </p>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <button
    mat-raised-button
    color="accent"
    class="button primary update-button"
    type="submit"
    [disabled]="state.loading$ | async"
    trans
  >
    Update
  </button>
  <mat-progress-bar
    mode="indeterminate"
    color="accent"
    *ngIf="state.loading$ | async"
  ></mat-progress-bar>
</form>
